import { render, staticRenderFns } from "./AdminContrattiTerminatiView.vue?vue&type=template&id=bb668b2c&"
import script from "./AdminContrattiTerminatiView.vue?vue&type=script&lang=ts&"
export * from "./AdminContrattiTerminatiView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports